<template>
	<div class="modal-backdrop" v-if="enabled && renderable">
		<div class="modal-dimmer" :style="dimmerStyle"></div>
		<div class="modal-join-prompt" :style="modalStyle">
			<div class="modal-join-prompt__inner">
				<img src="/images/modal/prompt.svg" class="modal-join-prompt__image" alt="Join the community" loading="lazy"/>
				<div class="modal-join-prompt__body">
					<h2 class="modal-message__title">Join the community</h2>
					<div class="modal-message__text">Get matched with a job that matters to you &amp; the world</div>
					<div class="modal-message__join">
						<button @click.prevent="doAction('join')" class="btn btn-blue-light uppercase">Sign up quickly</button>
					</div>
					<div class="modal-message__login">
						<p>Already have an account? <a href="#" @click.prevent="doAction('login')">Login</a></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ls from 'localstorage-slim';

  export default {
    name: 'ModalJoinPrompt',

    components: {

    },

    props: {

    },

    emits: [],

    data() {
      return {
				scrollPosition: 0,
				renderable: true
      }
    },

    created() {
			this.renderable = (ls.get('esc_mjp', { decrypt: true }) === true);
			ls.set('esc_mjp', true, { ttl: (60*30), encrypt: true }); // 30 mins
		},

    mounted() {
			if (this.renderable) {
				this.emitter.emit("removeSignInPromptTimeout");
			}
			window.addEventListener('scroll', this.updateScroll);
    },

		beforeUnmount() {
			window.removeEventListener('scroll', this.updateScroll);
		},

    methods: {
			updateScroll() {
				this.scrollPosition = window.scrollY;
			},
			doAction(type) {
				this.emitter.emit("openModal", { name: 'SignIn', message: false, persistent: true, mode: type });
			}
    },

    computed: {
			enabled() {
				return (this.scrollPosition > 0);
			},
			dimmerStyle() {
				let dist = Math.min(this.scrollPosition,400);
				return 'opacity:'+dist/400;
			},
			modalStyle() {
				let dist = Math.min(this.scrollPosition,200)/200;
				return 'transform: translateY(' + (100-(dist*100)) + '%);';
			}
    }
  };
</script>
